import { ref } from 'firebase/storage';

import { storage } from './Firebase';

// eslint-disable-next-line import/prefer-default-export
export const getCompanyStorage = (companyId) =>
  ref(storage, `companies/${companyId}/`);
